module.exports = __webpack_public_path__ + "static/media/count_back.521add03.svg";